import React from 'react';
import './Wallets.css';

const Wallets: React.FC = () => {
  return (
    <div className="wallets-page">
      <div className="page-header">
        <h1>Wallets</h1>
        <p className="page-description">Manage your linked wallet addresses</p>
      </div>
      <div className="page-content">
        <div className="empty-state">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
            <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
            <path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path>
          </svg>
          <h2>Coming Soon</h2>
          <p>Wallet management features will be available here.</p>
        </div>
      </div>
    </div>
  );
};

export default Wallets;

